import { useMutation, useSuspenseQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { createApiKey } from "./create-api-key";
import { apiKeysQueryOptions } from "./get-api-keys";
import { apiKeysKeys } from "./query-keys";
import { revokeApiKey } from "./revoke-api-key";

export const useGetApiKeys = (projectId: string, organizationId: string) =>
  useSuspenseQuery({
    ...apiKeysQueryOptions({ projectId, organizationId }),
  });

export const useRevokeApiKey = (
  keyId: string,
  projectId: string,
  organizationId: string
) =>
  useMutation({
    mutationFn: () => revokeApiKey({ projectId, keyId, organizationId }),
    meta: {
      invalidates: [apiKeysKeys.list({ scope: { organizationId, projectId } })],
      errorMessage: "Failed to revoke API key",
    },
    onSuccess: () => {
      toast.success("API key revoked successfully");
    },
  });

export const useCreateApiKey = (projectId: string, organizationId: string) =>
  useMutation({
    mutationFn: ({ label, expiresAt }: { label: string; expiresAt?: string }) =>
      createApiKey({ projectId, label, organizationId, expiresAt }),
    meta: {
      invalidates: [apiKeysKeys.list({ scope: { organizationId, projectId } })],
      errorMessage: "Failed to create API key",
    },
    onSuccess: () => {
      toast.success("API key created successfully");
    },
  });
